import React, { useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import FemtyzHome from "./pages/FemtyzHome";
import Settings from "./pages/Settings";
import AuthOverlay from "./components/auth/AuthOverlay";
import MobileMenuDrawer from "./components/MobileMenuDrawer";

function AppShell() {
  const [auth, setAuth] = useState({ open: false, mode: "login" });
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  function handleOpenAuth(mode) {
    setAuth({ open: true, mode: mode || "login" });
  }

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <FemtyzHome
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/settings"
          element={
            <Settings
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
      </Routes>

      <AuthOverlay
        open={auth.open}
        initialMode={auth.mode}
        onClose={() => setAuth((s) => ({ ...s, open: false }))}
      />
      <MobileMenuDrawer
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onOpenAuth={handleOpenAuth}
        onSelectMenuItem={(key) => {
          if (key === "home") navigate("/");
          if (key === "settings") navigate("/settings");
        }}
      />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
